import ComponentDescription from "components/customs/ComponentDescription";
import ComponentHeader from "components/cms/ComponentHeader";
import { IframeDefinitions } from "./IframeDefinitions";

export class Iframe extends IframeDefinitions {
    render() {
        const { className, designing } = this.props;

        return (
            <div
                data-schema-id={this.props.id}
                className={[
                    "fa-Iframe fa-draggable",
                    designing && "designing",
                    className,
                ]
                    .filter((e) => !!e)
                    .join(" ")}
            >
                {designing && (
                    <ComponentHeader
                        componentEntry={this.props.entry}
                        componentSchemaId={this.props.id as string}
                    />
                )}
                <ComponentDescription
                    node={this.props.schemaNode}
                    entry={this.props.entry}
                />
            </div>
        );
    }
}
